export const pValueToConfidenceLabel = (p: number): string => {
	if (p < 0.01) return "Very confident";
	if (p < 0.05) return "Confident";
	if (p < 0.1) return "Moderate confidence";
	return "Not enough evidence";
};
